module.exports = __webpack_public_path__ + "media/common/images/badges/gray/super_pruvodce-22fd427e22005d3b805527c0ef8ae614.svg";